import { View } from 'backbone';
import template  from 'designer/modals/ai-chat-modal.ejs';
import { handleUserMessage, handleUserMessageWithFile, UpdateAIResponseRating, GetMessageLimitAndUsage } from "../../../service/ai/api.js";
import AIConnectionBuilder from "../../../service/ai/AIConnectionBuilder.js";
import listService          from 'ListService';
import constants from "Constants";

class AIChatModal extends View {
    initialize(opts) {
        this.options = opts || {};
        this.template = template;
        this.tagName = 'div';
        this.id = opts.el;
        this.El = "#ai-chat-modal";
        this.mode = opts.mode || 'dialog'; // 'dialog' or 'panel'

        this.messageLimit = 0;
        this.messagesUsed = 0;
        this.conversationHistory = [];
        this.connectionBuildingType = null;
        this.connectionJustCreated = false;
        this.pendingFile = null;
        this.messageIndex = 0;
        this.userInitials = this.getUserInitials();
        this.userContext = opts.userContext || '';
        this.contextProvider = opts.contextProvider || null;

        return this;
    }

    createResponseContainer(id, showActions, initialStatus) {
        let actionsHtml = '';
        if (showActions === 'minimal') {
            actionsHtml = `<div class="msg-actions ai-actions" style="visibility:hidden">
                                    <button class="msg-action-btn action-copy" title="Copy"><span class="glyphicon glyphicon-copy"></span></button>
                                    <button class="msg-action-btn action-thumbup" title="Helpful"><span class="glyphicon glyphicon-thumbs-up"></span></button>
                                    <button class="msg-action-btn action-thumbdown" title="Not helpful"><span class="glyphicon glyphicon-thumbs-down"></span></button>
                                </div>`;
        } else if (showActions !== false) {
            actionsHtml = `<div class="msg-actions ai-actions" style="visibility:hidden">
                                    <button class="msg-action-btn action-copy" title="Copy"><span class="glyphicon glyphicon-copy"></span></button>
                                    <button class="msg-action-btn action-thumbup" title="Helpful"><span class="glyphicon glyphicon-thumbs-up"></span></button>
                                    <button class="msg-action-btn action-thumbdown" title="Not helpful"><span class="glyphicon glyphicon-thumbs-down"></span></button>
                                    <button class="msg-action-btn action-retry" title="Retry"><span class="glyphicon glyphicon-refresh"></span></button>
                                </div>`;
        }

        const statusMsg = initialStatus || 'Searching knowledge base';
        let messageBox = `<div class="ai-response ${id}" data-msg-index="${this.messageIndex}">
                            <div class="ai-img">
                                <img src="${ require('chat-bot/chatbot_blink_circle_whiteBCK.gif')}" width="36px" />
                            </div>
                            <div class="ai-response-content">
                                <div class="ai-status-text"><span class="status-icon">&#9679;</span> ${statusMsg}<span class="dot-anim"></span></div>
                                <div class="message-box answer" style="display:none">
                                    <p class="ai-text"></p>
                                    <div class="ai-sources" style="display:none"></div>
                                    ${actionsHtml}
                                </div>
                            </div>
                        </div>`;

        $(".ai-chat").append(messageBox);
        this.messageIndex++;

        // Scroll to bottom so user sees the status
        const chatEl = $(".ai-chat")[0];
        if (chatEl) chatEl.scrollTop = chatEl.scrollHeight;
    }

    stripHtml(html) {
        return html.replace(/<br\s*\/?>/gi, '\n').replace(/<[^>]+>/g, '');
    }

    validateFile(file) {
        const ALLOWED = ['.yaml', '.yml', '.json', '.xml', '.wsdl'];
        const MAX_SIZE = 2 * 1024 * 1024;
        const ext = '.' + file.name.split('.').pop().toLowerCase();
        if (!ALLOWED.includes(ext)) return 'Unsupported file type. Accepted: .yaml, .yml, .json, .xml, .wsdl';
        if (file.size > MAX_SIZE) return 'File too large. Maximum size is 2MB.';
        if (file.size === 0) return 'File is empty.';
        return null;
    }

    attachFile(file) {
        const error = this.validateFile(file);
        if (error) {
            this.createResponseContainer("ai-file-error-" + this.messageIndex, false);
            this.setAnswer("ai-file-error-" + this.messageIndex, { answer: error });
            return;
        }
        this.pendingFile = file;
        const sizeKB = (file.size / 1024).toFixed(1);
        const chipHtml = `<div class="ai-file-chip">
            <span class="glyphicon glyphicon-file"></span>
            <span class="file-chip-name">${file.name}</span>
            <span class="file-chip-size">(${sizeKB} KB)</span>
            <span class="file-chip-remove glyphicon glyphicon-remove" title="Remove file"></span>
        </div>`;
        $('.ai-file-chip-area').html(chipHtml);
        $("#userInput").focus();
    }

    removeFile() {
        this.pendingFile = null;
        $('.ai-file-chip-area').empty();
    }

    isConnectionBuildingIntent(question) {
        // Already in a connection-building flow from type chooser
        if (this.connectionBuildingType) return true;

        // Don't trigger connection building after a connection was just created
        if (this.createdResult || this.connectionJustCreated) return false;

        const isConnectionsContext = /Connections|REST Web Service|SOAP Web Service|Database/i.test(this.userContext);
        const hasUrl = /https?:\/\/[^\s]+/i.test(question);
        const hasKeywords = /connect|api|webservice|web service|wsdl|soap|database|connection agent|integrate|set up|create connection|vector|pinecone|vector database|embedding/i.test(question);
        return isConnectionsContext && (hasUrl || hasKeywords);
    }

    startStatusCycle($container, isConnectionBuilding = false) {
        const messages = isConnectionBuilding ? [
            'Fetching API documentation',
            'Analyzing API endpoints',
            'Identifying authentication method',
            'Building connection proposal'
        ] : [
            'Searching knowledge base',
            'Analyzing your question',
            'Finding relevant information',
            'Preparing response'
        ];
        let index = 0;
        this._statusInterval = setInterval(() => {
            index = (index + 1) % messages.length;
            const $status = $container.find('.ai-status-text');
            if ($status.length) {
                $status.html(`<span class="status-icon">&#9679;</span> ${messages[index]}<span class="dot-anim"></span>`);
            }
        }, 2500);
    }

    stopStatusCycle() {
        if (this._statusInterval) {
            clearInterval(this._statusInterval);
            this._statusInterval = null;
        }
    }

    createNewQuestion(question) {
        let userQuestion = `<div class="ai-ask" data-msg-index="${this.messageIndex}" data-question="${this.escapeHtml(question)}">
                            <div class="user-avatar">${this.userInitials}</div>
                            <div class="message-box ask">
                                <p class="ai-text">${question.replace(/\n/g, '<br/>')}</p>
                                <div class="msg-actions user-actions">
                                    <button class="msg-action-btn action-copy" title="Copy"><span class="glyphicon glyphicon-copy"></span></button>
                                    <button class="msg-action-btn action-edit" title="Edit"><span class="glyphicon glyphicon-pencil"></span></button>
                                </div>
                            </div>
                        </div>`;

        $(".ai-chat").append(userQuestion);
        this.messageIndex++;
        const chatEl = $(".ai-chat")[0];
        if (chatEl) chatEl.scrollTop = chatEl.scrollHeight;
    }

    getUserInitials() {
        try {
            const profile = JSON.parse(localStorage.getItem('profile'));
            const first = profile.FirstName || '';
            const last = profile.LastName || '';
            if (first && last) {
                return (first[0] + last[0]).toUpperCase();
            }
            return (first || last).substring(0, 2).toUpperCase() || 'U';
        } catch (e) {
            return 'U';
        }
    }

    escapeHtml(text) {
        if (!text) return '';
        return text.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    setAnswer(id, response, useTypewriter) {
        const $container = $(`.${id}`);

        // Store responseId on the container for action buttons
        if (response.responseId) {
            $container.attr('data-response-id', response.responseId);
        }

        // Hide status text
        $container.find(".ai-status-text").hide();

        // Show message box
        $container.find(".message-box").show();

        if (useTypewriter && response.answer) {
            // Change status to "Generating response..." briefly
            $container.find('.ai-text').html('');
            this.typewriterEffect($container, response);
        } else {
            // Instant display (greeting, errors)
            $container.find('.ai-text').html(response.answer);
            this.showSourcesAndFinish($container, response);
        }
    }

    typewriterEffect($container, response) {
        const $textEl = $container.find('.ai-text');
        const html = response.answer;

        // Parse HTML into tokens: tags (kept whole) and text characters
        const tokens = [];
        let i = 0;
        while (i < html.length) {
            if (html[i] === '<') {
                const end = html.indexOf('>', i);
                if (end !== -1) {
                    tokens.push(html.substring(i, end + 1));
                    i = end + 1;
                } else {
                    tokens.push(html[i]);
                    i++;
                }
            } else if (html[i] === '&') {
                const end = html.indexOf(';', i);
                if (end !== -1 && end - i < 10) {
                    tokens.push(html.substring(i, end + 1));
                    i = end + 1;
                } else {
                    tokens.push(html[i]);
                    i++;
                }
            } else {
                tokens.push(html[i]);
                i++;
            }
        }

        let current = 0;
        let buffer = '';
        const speed = 15; // ms per token

        const type = () => {
            if (current < tokens.length) {
                const chunk = Math.min(3, tokens.length - current); // 3 tokens at a time for speed
                for (let j = 0; j < chunk; j++) {
                    buffer += tokens[current++];
                }
                $textEl.html(buffer);

                // Auto-scroll during typing
                const $chat = $(".ai-chat");
                $chat[0].scrollTop = $chat[0].scrollHeight;

                setTimeout(type, speed);
            } else {
                // Done typing - show sources and actions
                this.showSourcesAndFinish($container, response);
            }
        };

        type();
    }

    showSourcesAndFinish($container, response) {
        if (response.sources) {
            const $sources = $container.find('.ai-sources');
            $sources.html(response.sources);
            $sources.show();
        }

        // Show action buttons
        $container.find('.msg-actions').css('visibility', 'visible');

        // Show pending proposal/fallback after typewriter finishes
        if (this.pendingProposal) {
            const proposal = this.pendingProposal;
            this.showConnectionProposal(proposal);
            // pendingProposal is now re-set inside showConnectionProposal for the Create button
        } else if (this.pendingFallback) {
            this.showConnectionFallback();
            this.pendingFallback = false;
        } else if (this.pendingConnectionChooser) {
            this.showConnectionTypeChooser();
            this.pendingConnectionChooser = false;
        }

        const chatEl = $(".ai-chat")[0];
        if (chatEl) chatEl.scrollTop = chatEl.scrollHeight;
        $("#userInput").prop("readonly", false);
    }

    parseMarkdown(text) {
        // Parse markdown tables first (before line break conversion)
        text = this.parseMarkdownTables(text);

        return text
            // Headers: ### Header → <strong>Header</strong>
            .replace(/^#{1,3}\s+(.+)$/gm, '<strong>$1</strong>')
            // Bold: **text** or __text__
            .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
            .replace(/__(.+?)__/g, '<strong>$1</strong>')
            // Italic: *text* or _text_ (but not inside words)
            .replace(/(?<!\w)\*([^*]+?)\*(?!\w)/g, '<em>$1</em>')
            .replace(/(?<!\w)_([^_]+?)_(?!\w)/g, '<em>$1</em>')
            // Inline code: `code`
            .replace(/`([^`]+?)`/g, '<code style="background:#f0f0f0;padding:1px 4px;border-radius:3px;font-size:12px;">$1</code>')
            // Unordered lists: - item or * item
            .replace(/^[\-\*]\s+(.+)$/gm, '<li>$1</li>')
            // Links: [text](url)
            .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank">$1</a>')
            // Line breaks
            .replace(/\n/g, '<br/>');
    }

    parseMarkdownTables(text) {
        const lines = text.split('\n');
        const result = [];
        let i = 0;

        while (i < lines.length) {
            // Detect table: line with pipes, followed by separator line (|---|---|)
            if (i + 1 < lines.length &&
                lines[i].includes('|') &&
                /^\|?[\s\-:|]+\|[\s\-:|]+\|?$/.test(lines[i + 1].trim())) {

                // Parse header row
                const headerCells = lines[i].split('|').map(c => c.trim()).filter(c => c !== '');
                let tableHtml = '<table class="ai-md-table"><thead><tr>';
                headerCells.forEach(cell => {
                    tableHtml += `<th>${cell}</th>`;
                });
                tableHtml += '</tr></thead><tbody>';

                // Skip separator line
                i += 2;

                // Parse body rows
                while (i < lines.length && lines[i].includes('|') && lines[i].trim() !== '') {
                    const cells = lines[i].split('|').map(c => c.trim()).filter(c => c !== '');
                    tableHtml += '<tr>';
                    cells.forEach(cell => {
                        tableHtml += `<td>${cell}</td>`;
                    });
                    tableHtml += '</tr>';
                    i++;
                }

                tableHtml += '</tbody></table>';
                result.push(tableHtml);
            } else {
                result.push(lines[i]);
                i++;
            }
        }

        return result.join('\n');
    }

    formatAnswer(response) {
        if (response.answer) {
            let sources = null;
            if (response.sources) {
                sources = "Sources<br>" + response.sources.split("<br/>").map(link => `<a href="${link}" target="_blank" class="source-link">${link}</a>`).join('<br/>');
            }

            let formattedAnswer = this.parseMarkdown(response.answer);

            this.setAnswer('ai-answer-' + this.messagesUsed, { answer: formattedAnswer, sources: sources, responseId: response.responseId }, true);
        }

        $("#userInput").val("");
        $("#userInput").trigger("focus");
    }

    buildGreeting() {
        const context = this.contextProvider ? this.contextProvider() : this.userContext;

        // Connections section (any sub-type)
        if (/Connections|REST Web Service|SOAP Web Service|Database|Directory Service/i.test(context)) {
            return "Hi! I see you're working with <strong>Connections</strong>.</br>" +
                "PerfectApps supports: <strong>Databases, Directory Services (LDAP/AD), SOAP Web Services, REST Web Services, Apps, and Text Files</strong>.</br>" +
                "I can help you create and configure connections automatically — which type would you like to create?</br>" +
                "Feel free to ask me any question about connections and I'll help you out.";
        }

        // Dashboard sections
        if (/Report Designer/i.test(context)) {
            return "Hi! I see you're in the <strong>Report Designer</strong>.</br>" +
                "I can help you with data grids, charts, filters, and report layout.</br>" +
                "Feel free to ask me any question about report design and I'll help you out.";
        }
        if (/Reports/i.test(context)) {
            return "Hi! You're in the <strong>Reports</strong> section.</br>" +
                "I can help you create reports, configure data sources, and design visualizations.</br>" +
                "Feel free to ask me any question about reports and I'll help you out.";
        }
        if (/Notifications/i.test(context)) {
            return "Hi! You're in <strong>Notifications</strong>.</br>" +
                "I can help you with notification rules, failed notifications, and alert configuration.</br>" +
                "Feel free to ask me any question about notifications and I'll help you out.";
        }
        if (/Settings/i.test(context)) {
            return "Hi! You're in <strong>Settings</strong>.</br>" +
                "I can help you with user management, account configuration, email setup, and more.</br>" +
                "Feel free to ask me any question about settings and I'll help you out.";
        }

        // Designer modes
        if (/Layout Designer/i.test(context)) {
            return "Hi! I see you're in the <strong>Layout Designer</strong>.</br>" +
                "I can help you with form controls, layout, styling, and field configuration.</br>" +
                "Feel free to ask me any question about form design and I'll help you out.";
        }
        if (/Behaviors Editor/i.test(context)) {
            return "Hi! You're in the <strong>Behaviors Editor</strong>.</br>" +
                "I can help you with actions, conditions, validations, and form logic.</br>" +
                "Feel free to ask me any question about behaviors and I'll help you out.";
        }
        if (/Workflow Editor/i.test(context)) {
            return "Hi! You're in the <strong>Workflow Editor</strong>.</br>" +
                "I can help you with stages, transitions, approvals, and routing.</br>" +
                "Feel free to ask me any question about workflows and I'll help you out.";
        }
        if (/Mobile Designer/i.test(context)) {
            return "Hi! You're in the <strong>Mobile Designer</strong>.</br>" +
                "I can help you with the mobile layout of your app.</br>" +
                "Feel free to ask me any question about mobile design and I'll help you out.";
        }

        // Apps section
        if (/Apps/i.test(context)) {
            return "Hi! You're in the <strong>Apps</strong> section.</br>" +
                "I can help you create new apps, manage existing ones, and navigate the dashboard.</br>" +
                "Feel free to ask me any question about apps and I'll help you out.";
        }

        // Default fallback
        return "Hi! I'm your PerfectApps assistant.</br>" +
            "I can help you with anything in the application — from building forms and reports to setting up connections and workflows.</br>" +
            "Feel free to ask me any question and I'll help you out.";
    }

    async greeting() {
        let greeting = this.buildGreeting();

        const context = this.contextProvider ? this.contextProvider() : this.userContext;
        if (/Connections|REST Web Service|SOAP Web Service|Database|Directory Service/i.test(context)) {
            this.pendingConnectionChooser = true;
        }

        this.createResponseContainer("ai-greeting", false);
        this.setAnswer("ai-greeting", {answer: greeting});

        // Add greeting to conversation history so backend has context
        this.updateConversationHistory('assistant', this.stripHtml(greeting));

        await this.fetchMessageLimits();

        const remaining = this.messageLimit - this.messagesUsed;
        if (remaining === 0) {
            greeting = `I'm sorry, it seems you have reached your questions limit.
                        Please contact our <a href="${constants.APP_URL}/resources/" target="_blank">sales team</a> for further assistance.`;

            this.createResponseContainer("ai-limit", false);
            this.setAnswer("ai-limit", {answer: greeting});

            $(".search-area").hide();
            $("#messageCounter").hide();
        } else {
            $(".search-area").show();
            $("#messageCounter").show();
        }
    }

    async askAI(question, file = null) {
        // Refresh context dynamically in panel mode (user may have navigated)
        // But don't override if we're in a connection-building flow (user picked a type)
        if (this.contextProvider && !this.connectionBuildingType) {
            this.userContext = this.contextProvider();
        }

        // Detect if user wants to switch connection type mid-flow — show chooser again
        if (this.connectionBuildingType) {
            const q = question.toLowerCase();
            const typePatterns = [
                { keys: ['rest', 'rest api', 'restful', 'rest web service'], type: 'rest' },
                { keys: ['soap', 'soap web service', 'wsdl'], type: 'soap' },
                { keys: ['database', 'db connection', 'connection agent'], type: 'database' },
                { keys: ['ldap', 'active directory', 'directory service'], type: 'ldap' },
                { keys: ['google sheet', 'google sheets', 'spreadsheet'], type: 'google-sheets' },
                { keys: ['text file', 'csv', 'delimited'], type: 'text-files' },
                { keys: ['apps connection', 'perfectapps connection', 'app connection'], type: 'apps' }
            ];
            const switchTo = typePatterns.find(tp => tp.type !== this.connectionBuildingType && tp.keys.some(k => q.includes(k)));
            if (switchTo) {
                this.connectionBuildingType = null;
                this.userContext = 'Connections';
                this.conversationHistory = [];
                this.displayQuestion(question);
                this.createResponseContainer("ai-switch-type", false);
                this.setAnswer("ai-switch-type", {
                    answer: "It looks like you'd like a different connection type. Let me show you the options again:"
                });
                this.showConnectionTypeChooser();
                return;
            }
        }

        const isConnBuilding = file || this.isConnectionBuildingIntent(question);
        const initialStatus = isConnBuilding ? 'Fetching API documentation' : 'Searching knowledge base';
        this.createResponseContainer("ai-answer-" + this.messagesUsed, undefined, initialStatus);
        const $currentContainer = $(`.ai-answer-${this.messagesUsed}`);
        this.startStatusCycle($currentContainer, isConnBuilding);

        try {
            this.trimHistory();
            const isFirstQuestion = this.conversationHistory.length === 0;
            const history = isFirstQuestion ? [] : this.conversationHistory;
            const response = file
                ? await handleUserMessageWithFile(file, question, history, this.userContext)
                : await handleUserMessage(question, history, this.userContext);

            const answer = response.message;
            const sources = (response.txtPaths || []).join("<br/>");
            const supportText = response.supportText || '';

            this.currentResponseId = response.newID;

            this.updateConversationHistory('user', question);
            this.updateConversationHistory('assistant', answer);
            if (supportText) this.updateConversationHistory('assistant', supportText);

            // Stop cycling and update status
            this.stopStatusCycle();

            // Check if response has a proposal — if so, skip the text message and show proposal directly
            const hasProposal = response.action && response.action.type === 'create_connection'
                && response.action.data && response.action.data.actions && response.action.data.actions.length > 0;

            if (hasProposal) {
                // Remove the status container — proposal card replaces it
                $currentContainer.remove();
                this.showConnectionProposal(response.action.data);
            } else {
                $currentContainer.find('.ai-status-text').html('<span class="status-icon done">&#10003;</span> Generating response...');
                this.formatAnswer({answer, sources, responseId: response.newID});

                if (isConnBuilding && !response.action && this.connectionBuildingType !== 'database' && this.connectionBuildingType !== 'text-files' && this.connectionBuildingType !== 'ldap' && this.connectionBuildingType !== 'apps') {
                    this.pendingFallback = true;
                }
            }

            if (response.updatedMessagesUsed) {
                this.messagesUsed = response.updatedMessagesUsed;
                this.updateMessageCounter();
            }
        } catch (error) {
            this.stopStatusCycle();
            console.log("Error asking AI:", error);
            this.setAnswer('ai-answer-' + this.messagesUsed, {answer: "I apologize, but the answer to this question is beyond my current knowledge."});
        }
    }

    updateConversationHistory(role, content) {
        this.conversationHistory.push({ role: role, content: content });
    }

    trimHistory(maxEntries = 30) {
        if (this.conversationHistory.length <= maxEntries) return;
        const first = this.conversationHistory.slice(0, 2);
        const recent = this.conversationHistory.slice(-1 * (maxEntries - 2));
        this.conversationHistory = [...first, ...recent];
    }

    async submitFeedback(rating, $container) {
        const responseId = $container.attr('data-response-id');
        const $thumbUp = $container.find('.action-thumbup');
        const $thumbDown = $container.find('.action-thumbdown');

        try {
            await UpdateAIResponseRating(responseId, rating);
            if (rating) {
                $thumbUp.addClass('active');
                $thumbDown.removeClass('active');
            } else {
                $thumbDown.addClass('active');
                $thumbUp.removeClass('active');
            }
        } catch (error) {
            console.error("Error updating AI response rating:", error);
        }
    }

    copyMessage($container) {
        const html = $container.find('.ai-text').html();
        // Convert HTML to formatted plain text
        const text = html
            .replace(/<br\s*\/?>/gi, '\n')
            .replace(/<\/p>/gi, '\n')
            .replace(/<\/div>/gi, '\n')
            .replace(/<\/li>/gi, '\n')
            .replace(/<li>/gi, '  - ')
            .replace(/<[^>]+>/g, '')
            .replace(/&amp;/g, '&')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&quot;/g, '"')
            .replace(/&#39;/g, "'")
            .replace(/\n{3,}/g, '\n\n')
            .trim();
        navigator.clipboard.writeText(text).then(() => {
            const $btn = $container.find('.action-copy');
            $btn.addClass('active');
            setTimeout(() => $btn.removeClass('active'), 1500);
        });
    }

    retryMessage($container) {
        const msgIndex = parseInt($container.attr('data-msg-index'));

        // Find the user question before this response
        const $userMsg = $container.prev('.ai-ask');
        if (!$userMsg.length) return;

        const question = $userMsg.attr('data-question');

        // Remove this response
        $container.remove();

        // Trim conversation history - remove last assistant entries
        while (this.conversationHistory.length > 0 &&
               this.conversationHistory[this.conversationHistory.length - 1].role === 'assistant') {
            this.conversationHistory.pop();
        }
        // Also remove the user entry since askAI will re-add it
        if (this.conversationHistory.length > 0 &&
            this.conversationHistory[this.conversationHistory.length - 1].role === 'user') {
            this.conversationHistory.pop();
        }

        this.askAI(question);
    }

    editMessage($container) {
        const question = $container.attr('data-question');
        const msgIndex = parseInt($container.attr('data-msg-index'));

        // Remove this message and everything after it
        const $allMessages = $(".ai-chat").children();
        let removing = false;
        $allMessages.each(function() {
            const idx = parseInt($(this).attr('data-msg-index'));
            if (idx >= msgIndex) {
                removing = true;
            }
            if (removing) {
                $(this).remove();
            }
        });

        // Trim conversation history to match
        // Each Q&A pair = 1 user + 2 assistant entries (answer + supportText)
        // Count remaining user messages to figure out how many history entries to keep
        const remainingUserMsgs = $(".ai-chat .ai-ask").length;
        // Each user msg generates: 1 user + 2 assistant = 3 entries
        this.conversationHistory = this.conversationHistory.slice(0, remainingUserMsgs * 3);

        // Put the question text in the input for editing
        $("#userInput").val(question);
        $("#userInput").trigger("focus");
    }

    async fetchMessageLimits() {
        try {
            const limits = await GetMessageLimitAndUsage();
            this.messageLimit = limits.MessageLimit;
            this.messagesUsed = limits.MessagesUsed;
            this.updateMessageCounter();
        } catch (error) {
            console.error("Error fetching message limits:", error);
        }
    }

    updateMessageCounter() {
        const remaining = this.messageLimit - this.messagesUsed;
        const counterMessage = `You currently have ${remaining} out of ${this.messageLimit} messages remaining. <br/>
        Should you require additional messages, please reach out to our <a href="${constants.APP_URL}/resources/" target="_blank">sales team</a> for further assistance.`;
        $('#messageCounter').html(counterMessage);
    }

    async render() {
        if (this.mode === 'panel') {
            return this.renderAsPanel();
        }
        return this.renderAsDialog();
    }

    async renderAsDialog() {
        return new Promise(async (resolve, reject) => {
            this.$el.html(template());
            $('body').append(this.$el);

            let self = this;

            this.dialog = $(self.El).dialog({
                autoOpen: true,
                height: 650,
                width: 600,
                minWidth: 350,
                minHeight: 300,
                top: 20,
                modal: false,
                resizable: true,
                classes: {
                    "ui-dialog": "dashboard-modal-dialog",
                    "ui-dialog-titlebar": "dashboard-modal-dialog-titlebar",
                    "ui-dialog-title": "dashboard-modal-title",
                    "ui-dialog-content": "chat-bot-modal-content"
                },
                position: {my: 'top+50',
                            at: 'center top',
                            of: 'body'},
                buttons: [],
                close: () => {
                    this.dialog.dialog("destroy");
                    this.closeModal();
                },
                open: () => {
                    this.greeting();
                }
            });

            $('div[role="dialog"]').draggable({containment: 'body'});

            this.delegateEvents();
            this.bindEvents();
            return this;
        });
    }

    renderAsPanel() {
        const $panel = $('#dashboard-right-panel');
        const $content = $('#AIChatPanelContent');

        // Render chat template into the panel content area
        $content.html(template());

        // Add resize handle if not already present
        if (!$panel.find('.panel-resize-handle').length) {
            $panel.prepend('<div class="panel-resize-handle"></div>');
        }

        // Show the panel and adjust layout
        $panel.show();
        $('body').addClass('ai-panel-open');

        // Show the chat content directly (no dialog wrapper needed)
        $(this.El).show().addClass('ai-panel-mode');

        this.delegateEvents();
        this.bindEvents();
        this.bindPanelEvents();
        this.greeting();

        return this;
    }

    bindPanelEvents() {
        const self = this;

        // Close button in panel header
        $('.right-panel-close').off().on('click', () => {
            self.closePanel();
        });

        // Resize handle - drag to resize panel width
        const $handle = $('.panel-resize-handle');
        const $panel = $('#dashboard-right-panel');

        $handle.off('mousedown').on('mousedown', (e) => {
            e.preventDefault();
            const startX = e.pageX;
            const startWidth = $panel.width();

            const onMouseMove = (e) => {
                const delta = startX - e.pageX;
                const newWidth = Math.min(Math.max(startWidth + delta, 300), 700);
                $panel.css('width', newWidth + 'px');
                $('.content-wrap').css('width', `calc(100vw - 250px - ${newWidth}px)`);
            };

            const onMouseUp = () => {
                $(document).off('mousemove', onMouseMove);
                $(document).off('mouseup', onMouseUp);
                $('body').removeClass('panel-resizing');
            };

            $('body').addClass('panel-resizing');
            $(document).on('mousemove', onMouseMove);
            $(document).on('mouseup', onMouseUp);
        });
    }

    closePanel() {
        $('#dashboard-right-panel').hide();
        $('body').removeClass('ai-panel-open');
        // Reset content-wrap width
        $('.content-wrap').css('width', '');
    }

    bindEvents() {
        const self = this;

        const ask = () => {
            const input = $("#userInput");
            const question = input.val();
            const file = self.pendingFile;

            if (question !== "" || file) {
                const displayText = file
                    ? (question ? `<span class="ai-file-indicator"><span class="glyphicon glyphicon-paperclip"></span> ${file.name}</span>\n${question}` : `<span class="ai-file-indicator"><span class="glyphicon glyphicon-paperclip"></span> ${file.name}</span>`)
                    : question;
                self.createNewQuestion(displayText);
                input.val("");
                input[0].style.height = 'auto';
                input.prop('readonly', true);
                self.removeFile();
                self.askAI(question, file);
            }
        };

        $("#userInput").on('keydown', (ev) => {
            if ((ev.key === 'Enter' || ev.code === 'Enter' || ev.code === 'NumpadEnter') && !ev.shiftKey) {
                ev.preventDefault();
                ask();
            }
        });

        // Auto-resize textarea as content grows
        $("#userInput").on('input', function() {
            this.style.height = 'auto';
            this.style.height = Math.min(this.scrollHeight, 120) + 'px';
        });

        $('.send-icon').on("click", () => {
            ask();
        });

        // File attach button
        $('.attach-icon').on("click", () => {
            $('#aiFileInput').trigger('click');
        });

        $('#aiFileInput').on("change", function() {
            if (this.files && this.files[0]) {
                self.attachFile(this.files[0]);
            }
            this.value = ''; // Reset so same file can be re-selected
        });

        // File chip remove
        $(document).on("click", ".file-chip-remove", () => {
            self.removeFile();
        });

        // Drag-drop on chat area
        $(".ai-chat").on("dragover", (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (!$('.ai-drop-overlay').length) {
                $(".ai-chat").append('<div class="ai-drop-overlay">Drop file here (.yaml, .yml, .json, .xml)</div>');
            }
        });

        $(".ai-chat").on("dragleave", (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (!$.contains($(".ai-chat")[0], e.relatedTarget)) {
                $('.ai-drop-overlay').remove();
            }
        });

        $(".ai-chat").on("drop", (e) => {
            e.preventDefault();
            e.stopPropagation();
            $('.ai-drop-overlay').remove();
            const files = e.originalEvent.dataTransfer.files;
            if (files && files[0]) {
                self.attachFile(files[0]);
            }
        });

        // Delegated events for action buttons
        $(".ai-chat").on("click", ".action-copy", function() {
            const $container = $(this).closest('.ai-response, .ai-ask');
            self.copyMessage($container);
        });

        $(".ai-chat").on("click", ".action-thumbup", function() {
            const $container = $(this).closest('.ai-response');
            self.submitFeedback(true, $container);
        });

        $(".ai-chat").on("click", ".action-thumbdown", function() {
            const $container = $(this).closest('.ai-response');
            self.submitFeedback(false, $container);
        });

        $(".ai-chat").on("click", ".action-retry", function() {
            const $container = $(this).closest('.ai-response');
            self.retryMessage($container);
        });

        $(".ai-chat").on("click", ".action-edit", function() {
            const $container = $(this).closest('.ai-ask');
            self.editMessage($container);
        });

        // Connection proposal buttons
        $(".ai-chat").on("click", ".action-create-connection", function() {
            self.createConnectionFromProposal();
        });

        $(".ai-chat").on("click", ".action-cancel-proposal", function() {
            self.cancelProposal();
        });

        // Test connection buttons
        $(".ai-chat").on("click", ".action-test-connection", function() {
            self.testConnection();
        });

        $(".ai-chat").on("click", ".action-skip-test", function() {
            self.skipTest();
        });

        // Credential form submit
        $(".ai-chat").on("click", ".action-submit-credentials", function() {
            self.submitTestCredentials();
        });

        // Connection type chooser clicks
        $(".ai-chat").on("click", ".connection-type-option", function() {
            const type = $(this).data('connection-type');
            self.handleConnectionTypeSelection(type);
        });

        // Database connection form
        $(".ai-chat").on("click", ".action-submit-db-connection", function() {
            self.submitDatabaseConnection();
        });

        $(".ai-chat").on("click", ".action-cancel-db-connection", function() {
            $('.ai-db-connection-form').remove();
            self.connectionBuildingType = null;
        });

        // Vector DB connection form
        $(".ai-chat").on("click", ".action-submit-vectordb-connection", function() {
            self.submitVectorDBConnection();
        });

        $(".ai-chat").on("click", ".action-cancel-vectordb-connection", function() {
            $('.ai-vectordb-form').remove();
            self.connectionBuildingType = null;
        });

        // Vector DB provider toggle in chat form
        $(".ai-chat").on("change", ".vectordb-provider-select", function() {
            const provider = $(this).val();
            $('.vectordb-chat-pinecone-field').toggle(provider === 'pinecone');
            $('.vectordb-chat-qdrant-field').toggle(provider === 'qdrant');
            $('.vectordb-chat-chroma-field').toggle(provider === 'chroma');
            $('.vectordb-chat-zilliz-field').toggle(provider === 'zilliz');
            $('.vectordb-chat-zilliz-info').toggle(provider === 'zilliz');
            $('.vectordb-chat-weaviate-field').toggle(provider === 'weaviate');
            // Weaviate OpenAI key: only if vectorizer = text2vec-openai
            if (provider === 'weaviate') {
                const vec = $('.vectordb-vectorizer-select').val();
                $('.vectordb-chat-weaviate-openai-field').toggle(vec === 'text2vec-openai');
            } else {
                $('.vectordb-chat-weaviate-openai-field').hide();
            }
            // Chroma: force semantic, disable search type
            const $searchType = $('.vectordb-search-type-select');
            $searchType.prop('disabled', provider === 'chroma');
            if (provider === 'chroma') $searchType.val('semantic');
            // Zilliz: hide keyword option
            $searchType.find('option[value=keyword]').toggle(provider !== 'zilliz' && provider !== 'chroma');
            $searchType.find('option[value=hybrid]').toggle(provider !== 'chroma');
            if ((provider === 'zilliz' || provider === 'chroma') && $searchType.val() === 'keyword') $searchType.val('semantic');
        });

        // Weaviate vectorizer toggle in chat form
        $(".ai-chat").on("change", ".vectordb-vectorizer-select", function() {
            const vec = $(this).val();
            $('.vectordb-chat-weaviate-openai-field').toggle(vec === 'text2vec-openai');
        });

        // App selector
        $(".ai-chat").on("click", ".action-confirm-app-selection", function() {
            self.confirmAppSelection();
        });

        $(".ai-chat").on("click", ".action-skip-app-selection", function() {
            self.skipAppSelection();
        });

        $(".ai-chat").on("click", ".action-select-all-apps", function(e) {
            e.preventDefault();
            const $checkboxes = $('.app-selector-checkbox');
            const allChecked = $checkboxes.length === $checkboxes.filter(':checked').length;
            $checkboxes.prop('checked', !allChecked);
            $(this).text(allChecked ? 'Select All' : 'Deselect All');
        });

        // Bulk sync prompt
        $(".ai-chat").on("click", ".action-sync-now", function() {
            self.startBulkSync();
        });

        $(".ai-chat").on("click", ".action-sync-later", function() {
            self.skipBulkSync();
        });

        // Fallback option clicks - prefill the input with a helpful hint
        $(".ai-chat").on("click", ".fallback-option", function() {
            const action = $(this).data('action');
            const $input = $(".ai-form-control");
            const hints = {
                'curl': 'curl -X GET "https://api.example.com/v1/endpoint?param=value" -H "Authorization: Bearer YOUR_KEY"',
                'manual': 'Base URL: https://api.example.com/v1\nEndpoints:\n- GET /endpoint1 (params: key, query)\n- POST /endpoint2 (body: name, value)\nAuth: API Key in header "X-API-Key"',
                'docs-link': 'Here is the API documentation: https://',
                'wsdl-link': 'https://example.com/service.asmx?wsdl',
                'wsdl-file': ''
            };
            if (action === 'wsdl-file') {
                // Trigger file upload dialog
                $('#aiFileInput').trigger('click');
                $('.ai-connection-fallback').remove();
                return;
            }
            $input.val(hints[action] || '').trigger('input').focus();
            if (hints[action]) $input[0].select();
            $('.ai-connection-fallback').remove();
        });

        // Switch connection type link in fallback card
        $(".ai-chat").on("click", ".action-switch-connection-type", function() {
            self.connectionBuildingType = null;
            self.userContext = 'Connections';
            self.conversationHistory = [];
            $('.ai-connection-fallback').remove();
            self.showConnectionTypeChooser();
        });
    }

    showConnectionProposal(proposal) {
        this.pendingProposal = proposal;

        const connType = proposal.connectionType || 'rest';
        const isDb = connType === 'database' || connType === 'textfile' || connType === 'ldap';
        const isSoap = connType === 'soap';
        const isApps = connType === 'apps';
        const isVectorDb = connType === 'vectordb';

        // Card title and icon
        const cardConfig = {
            'apps': { title: 'Apps Connection Proposal', icon: 'glyphicon-th' },
            'ldap': { title: 'Directory Services Connection Proposal', icon: 'glyphicon-folder-open' },
            'textfile': { title: 'Text File Connection Proposal', icon: 'glyphicon-file' },
            'database': { title: 'Database Connection Proposal', icon: 'glyphicon-hdd' },
            'soap': { title: 'SOAP Connection Proposal', icon: 'glyphicon-transfer' },
            'rest': { title: 'REST Connection Proposal', icon: 'glyphicon-cloud' },
            'vectordb': { title: 'Vector Database Connection Proposal', icon: 'glyphicon-grain' }
        }[connType] || { title: 'Connection Proposal', icon: 'glyphicon-transfer' };

        // Auth label
        const authLabel = {
            'none': 'None',
            'basic': 'Basic Auth (username/password)',
            'apikey': `API Key (${proposal.authDetails?.placement || 'query'} parameter: "${proposal.authDetails?.keyParam || 'key'}")`,
            'bearer': 'Bearer Token',
            'certificate': 'SSL Certificate',
            'sql': 'SQL Authentication',
            'windows': 'Windows Authentication'
        }[proposal.authType] || proposal.authType || 'None';

        // Database type label
        const dbTypeLabels = {
            'sqlserver': 'SQL Server', 'oracle': 'Oracle',
            'mysql': 'MySQL'
        };

        // Actions list
        const actions = proposal.actions || [];
        const actionTypeLabels = {
            'select': 'SELECT', 'read': 'READ', 'insert': 'INSERT', 'update': 'UPDATE',
            'delete': 'DELETE', 'storedprocedure': 'STORED PROC'
        };

        const actionsListHtml = actions.map(a => {
            const paramCount = (a.sendParams || []).length;
            if (isApps) {
                const totalParams = paramCount + (a.receiveParams || []).length;
                const fieldsLabel = totalParams > 0 ? `${totalParams} field${totalParams !== 1 ? 's' : ''}` : 'auto-mapped';
                return `<div class="proposal-action-item">
                    <span class="proposal-action-type">${actionTypeLabels[a.actionType] || a.actionType || 'READ'}</span>
                    <span class="proposal-operation">${this.escapeHtml(a.name)}</span>
                    <span class="proposal-param-count">${fieldsLabel}</span>
                </div>`;
            }
            if (isDb) {
                return `<div class="proposal-action-item">
                    <span class="proposal-action-type">${actionTypeLabels[a.actionType] || a.actionType || 'SELECT'}</span>
                    <span class="proposal-operation">${this.escapeHtml(a.tableName || a.name)}</span>
                    <span class="proposal-param-count">${paramCount} param${paramCount !== 1 ? 's' : ''}</span>
                </div>`;
            }
            if (isVectorDb) {
                const actionIcons = { 'query': '&#128269;', 'sync': '&#128228;', 'upsert': '&#128221;', 'delete': '&#128465;' };
                const icon = actionIcons[a.actionType] || '&#9679;';
                return `<div class="proposal-action-item">
                    <span class="proposal-action-type vectordb-action-type">${icon} ${this.escapeHtml(a.name || a.actionType || 'Action')}</span>
                    <span class="proposal-operation">${this.escapeHtml(a.description || '')}</span>
                </div>`;
            }
            if (isSoap) {
                return `<div class="proposal-action-item">
                    <span class="proposal-operation">${this.escapeHtml(a.operation || a.name)}</span>
                    <span class="proposal-param-count">${paramCount} param${paramCount !== 1 ? 's' : ''}</span>
                </div>`;
            }
            return `<div class="proposal-action-item">
                <span class="proposal-method">${a.method || 'GET'}</span>
                <span class="proposal-endpoint">${this.escapeHtml(a.endpoint)}</span>
                <span class="proposal-param-count">${paramCount} param${paramCount !== 1 ? 's' : ''}</span>
            </div>`;
        }).join('');

        const actionsLabel = isVectorDb ? 'Actions' : isApps ? 'Actions' : isDb ? 'Actions' : isSoap ? 'Operations' : 'Endpoints';

        // Extra fields based on type
        let extraFields = '';
        if (isApps) {
            extraFields = `
                ${proposal.appName ? `<div class="proposal-field"><span class="proposal-label">App:</span> <strong>${this.escapeHtml(proposal.appName)}</strong></div>` : ''}
            `;
        } else if (isDb) {
            extraFields = `
                ${proposal.agentUrl ? `<div class="proposal-field"><span class="proposal-label">Agent URL:</span> <span class="proposal-url">${this.escapeHtml(proposal.agentUrl)}</span></div>` : ''}
                ${proposal.datasourceName ? `<div class="proposal-field"><span class="proposal-label">Datasource:</span> <span class="proposal-db-type">${this.escapeHtml(proposal.datasourceName)}</span></div>` : ''}
                ${proposal.databaseName ? `<div class="proposal-field"><span class="proposal-label">Database:</span> ${this.escapeHtml(proposal.databaseName)}</div>` : ''}
            `;
        } else if (isSoap) {
            extraFields = `
                ${proposal.wsdlUrl ? `<div class="proposal-field"><span class="proposal-label">WSDL:</span> <span class="proposal-url">${this.escapeHtml(proposal.wsdlUrl)}</span></div>` : ''}
                ${proposal.targetNamespace ? `<div class="proposal-field"><span class="proposal-label">Namespace:</span> ${this.escapeHtml(proposal.targetNamespace)}</div>` : ''}
            `;
        } else if (isVectorDb) {
            const linkedApps = proposal.linkedApps || [];
            const linkedAppsHtml = linkedApps.length > 0
                ? `<div class="proposal-field vectordb-linked-apps">
                    <span class="proposal-label">Linked Apps:</span>
                    ${linkedApps.map(app => `<div class="vectordb-linked-app-item"><span class="glyphicon glyphicon-list-alt"></span> ${this.escapeHtml(app.formName)} <span class="vectordb-live-sync-badge">Live Sync: ON</span></div>`).join('')}
                   </div>`
                : '';
            const searchTypeLabels = { 'semantic': 'Semantic', 'keyword': 'Keyword', 'hybrid': 'Hybrid' };
            const providerLabels = { 'pinecone': 'Pinecone', 'qdrant': 'Qdrant', 'chroma': 'Chroma', 'zilliz': 'Zilliz', 'weaviate': 'Weaviate' };
            const p = proposal.provider || 'pinecone';
            extraFields = `
                ${p ? `<div class="proposal-field"><span class="proposal-label">Provider:</span> ${providerLabels[p] || p}</div>` : ''}
                ${p === 'pinecone' && proposal.indexName ? `<div class="proposal-field"><span class="proposal-label">Index:</span> ${this.escapeHtml(proposal.indexName)}</div>` : ''}
                ${p === 'qdrant' && proposal.collectionName ? `<div class="proposal-field"><span class="proposal-label">Collection:</span> ${this.escapeHtml(proposal.collectionName)}</div>` : ''}
                ${p === 'chroma' && proposal.chromaCollectionName ? `<div class="proposal-field"><span class="proposal-label">Collection:</span> ${this.escapeHtml(proposal.chromaCollectionName)}</div>` : ''}
                ${proposal.searchType ? `<div class="proposal-field"><span class="proposal-label">Search:</span> ${searchTypeLabels[proposal.searchType] || proposal.searchType}</div>` : ''}
                ${p === 'pinecone' && proposal.denseIndexHost ? `<div class="proposal-field"><span class="proposal-label">Dense Host:</span> <span class="proposal-url">${this.escapeHtml(proposal.denseIndexHost)}</span></div>` : ''}
                ${p === 'pinecone' && proposal.sparseIndexHost ? `<div class="proposal-field"><span class="proposal-label">Sparse Host:</span> <span class="proposal-url">${this.escapeHtml(proposal.sparseIndexHost)}</span></div>` : ''}
                ${p === 'pinecone' && (proposal.pineconeNamespace || proposal.namespace) ? `<div class="proposal-field"><span class="proposal-label">Namespace:</span> ${this.escapeHtml(proposal.pineconeNamespace || proposal.namespace)}</div>` : ''}
                ${p === 'pinecone' && proposal.cloud ? `<div class="proposal-field"><span class="proposal-label">Cloud:</span> ${this.escapeHtml(proposal.cloud)} / ${this.escapeHtml(proposal.region || '')}</div>` : ''}
                ${p === 'qdrant' && proposal.clusterUrl ? `<div class="proposal-field"><span class="proposal-label">Cluster:</span> <span class="proposal-url">${this.escapeHtml(proposal.clusterUrl)}</span></div>` : ''}
                ${p === 'qdrant' && proposal.denseModel ? `<div class="proposal-field"><span class="proposal-label">Dense Model:</span> ${this.escapeHtml(proposal.denseModel)}</div>` : ''}
                ${p === 'qdrant' && proposal.sparseModel ? `<div class="proposal-field"><span class="proposal-label">Sparse Model:</span> ${this.escapeHtml(proposal.sparseModel)}</div>` : ''}
                ${p === 'chroma' && proposal.chromaBaseUrl ? `<div class="proposal-field"><span class="proposal-label">Base URL:</span> <span class="proposal-url">${this.escapeHtml(proposal.chromaBaseUrl)}</span></div>` : ''}
                ${p === 'chroma' && proposal.chromaTenant ? `<div class="proposal-field"><span class="proposal-label">Tenant:</span> ${this.escapeHtml(proposal.chromaTenant)}</div>` : ''}
                ${p === 'chroma' && proposal.chromaDatabase ? `<div class="proposal-field"><span class="proposal-label">Database:</span> ${this.escapeHtml(proposal.chromaDatabase)}</div>` : ''}
                ${p === 'zilliz' && proposal.zillizCollection ? `<div class="proposal-field"><span class="proposal-label">Collection:</span> ${this.escapeHtml(proposal.zillizCollection)}</div>` : ''}
                ${p === 'zilliz' && proposal.zillizEndpoint ? `<div class="proposal-field"><span class="proposal-label">Endpoint:</span> <span class="proposal-url">${this.escapeHtml(proposal.zillizEndpoint)}</span></div>` : ''}
                ${p === 'zilliz' && proposal.zillizEmbeddingModel ? `<div class="proposal-field"><span class="proposal-label">Embedding:</span> ${this.escapeHtml(proposal.zillizEmbeddingModel)}</div>` : ''}
                ${p === 'zilliz' && proposal.zillizDimension ? `<div class="proposal-field"><span class="proposal-label">Dimension:</span> ${proposal.zillizDimension}</div>` : ''}
                ${p === 'weaviate' && proposal.weaviateUrl ? `<div class="proposal-field"><span class="proposal-label">Instance:</span> <span class="proposal-url">${this.escapeHtml(proposal.weaviateUrl)}</span></div>` : ''}
                ${p === 'weaviate' && proposal.weaviateCollection ? `<div class="proposal-field"><span class="proposal-label">Collection:</span> ${this.escapeHtml(proposal.weaviateCollection)}</div>` : ''}
                ${p === 'weaviate' && proposal.weaviateVectorizer ? `<div class="proposal-field"><span class="proposal-label">Vectorizer:</span> ${this.escapeHtml(proposal.weaviateVectorizer)}</div>` : ''}
                ${linkedAppsHtml}
            `;
        }

        // For database with no actions, show note
        const actionsSection = actions.length === 0 && isDb
            ? `<div class="proposal-endpoints"><div class="proposal-no-actions">Actions can be added after connecting to the database.</div></div>`
            : `<div class="proposal-endpoints">
                    <div class="proposal-endpoints-title">${actionsLabel} (${actions.length}):</div>
                    ${actionsListHtml}
               </div>`;

        // Update warning for Apps connections
        const hasUpdateAction = isApps && actions.some(a => a.actionType === 'update');
        const updateWarning = hasUpdateAction
            ? `<div class="proposal-update-warning"><span class="glyphicon glyphicon-warning-sign"></span> Please be aware that any empty parameters will clear the corresponding data in the application if left empty.</div>`
            : '';

        // URL field: databases may not have a traditional URL
        const urlField = proposal.url
            ? `<div class="proposal-field"><span class="proposal-label">${isDb ? 'Agent URL:' : 'URL:'}</span> <span class="proposal-url">${this.escapeHtml(proposal.url)}</span></div>`
            : '';

        const proposalHtml = `
            <div class="ai-connection-proposal" data-msg-index="${this.messageIndex}">
                <div class="proposal-header">
                    <span class="proposal-icon glyphicon ${cardConfig.icon}"></span>
                    <strong>${cardConfig.title}</strong>
                </div>
                <div class="proposal-details">
                    <div class="proposal-field"><span class="proposal-label">Name:</span> ${this.escapeHtml(proposal.name)}</div>
                    ${urlField}
                    ${extraFields}
                    <div class="proposal-field"><span class="proposal-label">Auth:</span> ${authLabel}</div>
                    ${proposal.description ? `<div class="proposal-field proposal-desc">${this.escapeHtml(proposal.description)}</div>` : ''}
                </div>
                ${actionsSection}
                ${updateWarning}
                <div class="proposal-buttons">
                    <button class="proposal-btn proposal-btn-create action-create-connection">Create Connection</button>
                    <button class="proposal-btn proposal-btn-cancel action-cancel-proposal">Cancel</button>
                </div>
            </div>`;

        $(".ai-chat").append(proposalHtml);
        this.messageIndex++;

        const chatEl = $(".ai-chat")[0];
        if (chatEl) chatEl.scrollTop = chatEl.scrollHeight;
    }

    async createConnectionFromProposal() {
        if (!this.pendingProposal) return;

        const proposal = this.pendingProposal;
        this.pendingProposal = null;

        // Disable buttons
        $('.action-create-connection, .action-cancel-proposal').prop('disabled', true);
        $('.action-create-connection').text('Creating...');

        // Create a status container for progress
        this.createResponseContainer("ai-builder-status", 'minimal', 'Creating connection and actions');
        const $statusContainer = $('.ai-builder-status');

        const onProgress = (msg) => {
            $statusContainer.find('.ai-status-text').html(`<span class="status-icon">&#9679;</span> ${msg}<span class="dot-anim"></span>`);
            const chatEl = $(".ai-chat")[0];
            if (chatEl) chatEl.scrollTop = chatEl.scrollHeight;
        };

        try {
            const result = await AIConnectionBuilder.createConnection(proposal, onProgress);

            // Build success message
            const totalProposed = (proposal.actions || []).length;
            let resultHtml = '';
            if (result.actionsCreated === totalProposed) {
                resultHtml = `Connection "<strong>${this.escapeHtml(result.connectionName)}</strong>" created successfully with ${result.actionsCreated} action${result.actionsCreated !== 1 ? 's' : ''}.`;
            } else {
                resultHtml = `Connection "<strong>${this.escapeHtml(result.connectionName)}</strong>" created with ${result.actionsCreated} of ${totalProposed} actions.`;
            }

            // Show AutoComplete results for database connections
            if (result.autoCompleteResults && result.autoCompleteResults.length > 0) {
                resultHtml += '<div class="ai-autocomplete-results"><strong>AutoComplete results:</strong>';
                result.autoCompleteResults.forEach(r => {
                    const icon = r.status === 'success' ? '&#10003;' : '&#10007;';
                    const cls = r.status === 'success' ? 'success' : 'error';
                    const detail = r.status === 'success' ? `${r.columnsFound} columns found` : (r.message || 'failed');
                    resultHtml += `<div class="autocomplete-result-row ${cls}"><span class="autocomplete-icon">${icon}</span> ${this.escapeHtml(r.actionName)} — ${detail}</div>`;
                });
                resultHtml += '</div>';
            }

            $statusContainer.find('.ai-status-text').hide();
            $statusContainer.find('.message-box').show();
            $statusContainer.find('.ai-text').html(resultHtml);
            $statusContainer.find('.msg-actions').css('visibility', 'visible');

            // Remove the proposal card
            $('.ai-connection-proposal').remove();

            // Store proposal + result for Phase 3 testing
            this.createdProposal = proposal;
            this.createdResult = result;
            this.connectionBuildingType = null;
            this.connectionJustCreated = true;

            // Update conversation history with creation outcome
            const actionNames = (proposal.actions || []).map(a => a.name).join(', ');
            this.updateConversationHistory('user', 'Create this connection');
            this.updateConversationHistory('assistant',
                `Connection "${result.connectionName}" (${proposal.connectionType || 'rest'}) created successfully with ${result.actionsCreated} actions: ${actionNames}. Connection ID: ${result.connectionId}`
            );

            // Test & Validate disabled for now
            // this.showTestConnectionCard(result);

            // Auto-navigate to the new connection
            if (result.connectionId) {
                this.navigateToConnection(result.connectionId);
            }

            // Show type chooser again for next action
            this.showConnectionTypeChooser();
        } catch (err) {
            // Re-enable buttons on error for retry
            $('.action-create-connection').prop('disabled', false).text('Create Connection');
            $('.action-cancel-proposal').prop('disabled', false);
            this.pendingProposal = proposal;

            $statusContainer.find('.ai-status-text').hide();
            $statusContainer.find('.message-box').show();
            $statusContainer.find('.ai-text').html(`Failed to create connection: ${err.message || 'Unknown error'}`);
            $statusContainer.find('.msg-actions').css('visibility', 'visible');

            // Update conversation history with failure
            this.updateConversationHistory('assistant',
                `Failed to create connection: ${err.message || 'Unknown error'}`
            );
        }

        const chatEl = $(".ai-chat")[0];
        if (chatEl) chatEl.scrollTop = chatEl.scrollHeight;
    }

    showTestConnectionCard(createResult) {
        const testCardHtml = `
            <div class="ai-test-connection-card" data-msg-index="${this.messageIndex}">
                <div class="test-card-header">
                    <span class="glyphicon glyphicon-flash"></span>
                    <strong>Test & Validate Connection</strong>
                </div>
                <div class="test-card-body">
                    <p>The connection and ${createResult.actionsCreated} action${createResult.actionsCreated !== 1 ? 's were' : ' was'} created.
                    Would you like to test each endpoint against the live API and auto-fix response parameters?</p>
                </div>
                <div class="test-card-buttons">
                    <button class="proposal-btn proposal-btn-create action-test-connection">Test & Validate</button>
                    <button class="proposal-btn proposal-btn-cancel action-skip-test">Skip</button>
                </div>
            </div>`;

        $(".ai-chat").append(testCardHtml);
        this.messageIndex++;

        const chatEl = $(".ai-chat")[0];
        if (chatEl) chatEl.scrollTop = chatEl.scrollHeight;
    }

    async testConnection() {
        if (!this.createdProposal || !this.createdResult) return;

        const proposal = this.createdProposal;
        const createResult = this.createdResult;

        // Disable buttons
        $('.action-test-connection, .action-skip-test').prop('disabled', true);
        $('.action-test-connection').text('Testing...');

        // Create status container
        this.createResponseContainer("ai-test-status", 'minimal', 'Testing actions against live API');
        const $statusContainer = $('.ai-test-status');
        this.startStatusCycle($statusContainer, false);

        // Override status messages for testing
        clearInterval(this._statusInterval);
        const testMessages = [
            'Calling API endpoints',
            'Validating response structure',
            'Analyzing response parameters',
            'Fixing receive parameters'
        ];
        let tIdx = 0;
        this._statusInterval = setInterval(() => {
            tIdx = (tIdx + 1) % testMessages.length;
            $statusContainer.find('.ai-status-text').html(`<span class="status-icon">&#9679;</span> ${testMessages[tIdx]}<span class="dot-anim"></span>`);
        }, 3000);

        try {
            const testResult = await AIConnectionBuilder.testConnection(proposal, createResult, (msg) => {
                $statusContainer.find('.ai-status-text').html(`<span class="status-icon">&#9679;</span> ${msg}<span class="dot-anim"></span>`);
            });

            this.stopStatusCycle();

            // Remove the test card
            $('.ai-test-connection-card').remove();

            // Check if backend is requesting credentials
            if (testResult.action && testResult.action.type === 'request_test_credentials') {
                $statusContainer.find('.ai-status-text').hide();
                $statusContainer.find('.message-box').show();
                $statusContainer.find('.ai-text').html(testResult.message || 'Credentials required to test this connection.');
                $statusContainer.find('.msg-actions').css('visibility', 'visible');
                this.showCredentialForm(testResult.action.data);
                this.updateConversationHistory('assistant', 'Test requires authentication credentials. Waiting for user to provide them.');
                return;
            }

            // Show test results
            $statusContainer.find('.ai-status-text').hide();
            $statusContainer.find('.message-box').show();
            $statusContainer.find('.msg-actions').css('visibility', 'visible');

            this.renderTestResults($statusContainer, testResult);

            // Update conversation history with test results
            if (testResult.results) {
                const summary = testResult.results.map(r => `${r.actionName}: ${r.status}`).join(', ');
                this.updateConversationHistory('assistant',
                    `Test results for "${this.createdResult.connectionName}": ${summary}`
                );
            }

            // Show parameter reference after test results
            if (this.createdProposal) {
                this.showParameterReference(this.createdProposal);
            }

            // Clear stored data
            this.createdProposal = null;
            this.createdResult = null;
        } catch (err) {
            this.stopStatusCycle();

            // Re-enable buttons for retry
            $('.action-test-connection').prop('disabled', false).text('Test & Validate');
            $('.action-skip-test').prop('disabled', false);

            $statusContainer.find('.ai-status-text').hide();
            $statusContainer.find('.message-box').show();
            $statusContainer.find('.ai-text').html(`Test failed: ${err.message || 'Unknown error'}. You can retry or skip.`);
        }

        const chatEl = $(".ai-chat")[0];
        if (chatEl) chatEl.scrollTop = chatEl.scrollHeight;
    }

    renderTestResults($container, testResult) {
        if (!testResult) {
            $container.find('.ai-text').html('Test completed but no results were returned.');
            return;
        }

        const results = testResult.results || [];

        // If no structured results, show the message text (with markdown parsing)
        if (!results.length) {
            const msg = testResult.message || 'Test completed but no detailed results were returned.';
            $container.find('.ai-text').html(this.parseMarkdown(msg));
            return;
        }

        // Determine status for each action from results
        const resultRows = results.map(r => {
            let status = r.status || 'passed';
            const errorMsg = r.error || '';
            let icon, statusClass, statusLabel, fixInfo = '';

            if (status === 'passed') {
                icon = '&#10003;';
                statusClass = 'test-passed';
                statusLabel = 'passed';
            } else if (status === 'fixed') {
                icon = '&#10003;';
                statusClass = 'test-fixed';
                statusLabel = 'fixed';
                if (r.totalPathsFound) {
                    fixInfo = `<span class="test-fix-details">(${r.totalPathsFound} paths found)</span>`;
                }
            } else {
                icon = '&#10007;';
                statusClass = 'test-failed';
                statusLabel = 'error';
                fixInfo = errorMsg ? `<span class="test-fix-details">${this.escapeHtml(errorMsg)}</span>` : '';
            }

            const name = r.actionName || r.name || 'Unknown';
            return `<div class="test-result-row ${statusClass}">
                <span class="test-result-icon">${icon}</span>
                <span class="test-result-name">${this.escapeHtml(name)}</span>
                <span class="test-result-status">${statusLabel}</span>
                ${fixInfo}
            </div>`;
        }).join('');

        const passed = results.filter(r => r.status === 'passed').length;
        const fixed = results.filter(r => r.status === 'fixed').length;
        const failed = results.filter(r => r.status !== 'passed' && r.status !== 'fixed').length;

        let summary = '';
        if (failed === 0 && fixed === 0) {
            summary = 'All actions passed!';
        } else if (failed === 0) {
            summary = 'All actions are now working correctly!';
        } else {
            summary = `${failed} action${failed !== 1 ? 's' : ''} could not be validated.`;
        }

        const html = `
            <div class="ai-test-results">
                <div class="test-results-header">
                    <span class="glyphicon glyphicon-ok-circle"></span>
                    <strong>Connection Test Results</strong>
                </div>
                <div class="test-results-body">
                    ${resultRows}
                </div>
                <div class="test-results-summary">
                    <span class="test-summary-stats">${passed} passed${fixed ? ', ' + fixed + ' fixed' : ''}${failed ? ', ' + failed + ' failed' : ''}</span>
                    <span class="test-summary-text">${summary}</span>
                </div>
            </div>`;

        $container.find('.ai-text').html(html);
    }

    showParameterReference(proposal) {
        const connType = proposal.connectionType || 'rest';
        const isDb = connType === 'database' || connType === 'textfile' || connType === 'ldap' || connType === 'apps';
        const isSoap = connType === 'soap';

        const operationLabels = {
            '0': '=', '1': '<', '2': '>', '3': '<=', '4': '>=', '5': '<>', '6': 'LIKE', '-1': 'return'
        };
        const actionTypeLabels = {
            'select': 'SELECT', 'insert': 'INSERT', 'update': 'UPDATE',
            'delete': 'DELETE', 'storedprocedure': 'STORED PROC'
        };

        const actionsHtml = (proposal.actions || []).map(action => {
            const sendRows = (action.sendParams || []).map(p => {
                const fixedNote = p.isFixed && p.fixedValue ? ` = "${this.escapeHtml(p.fixedValue)}"` : '';
                let detail;
                if (isDb) {
                    const op = operationLabels[p.operation] || p.operation || '=';
                    detail = `<span class="param-ref-type">${this.escapeHtml(p.column || p.name)}</span>
                              <span class="param-ref-placement">${op}</span>`;
                } else if (isSoap) {
                    detail = `<span class="param-ref-type">${this.escapeHtml(p.value || p.name)}</span>`;
                } else {
                    detail = `<span class="param-ref-type">${(p.dataType || 'String').replace('System.', '')}</span>
                              <span class="param-ref-placement">${p.placement || 'querystring'}</span>`;
                }
                return `<div class="param-ref-row">
                    <span class="param-ref-name">${this.escapeHtml(p.name)}${fixedNote}</span>
                    ${detail}
                    ${p.description ? `<span class="param-ref-desc">${this.escapeHtml(p.description)}</span>` : ''}
                </div>`;
            }).join('');

            const receiveRows = (action.receiveParams || []).map(p => {
                const typeInfo = isDb
                    ? this.escapeHtml(p.column || p.name)
                    : isSoap ? this.escapeHtml(p.path || p.value || p.name)
                    : (p.dataType || 'Object').replace('System.', '');
                return `<div class="param-ref-row">
                    <span class="param-ref-name">${this.escapeHtml(p.name)}</span>
                    <span class="param-ref-type">${typeInfo}</span>
                    ${p.description ? `<span class="param-ref-desc">${this.escapeHtml(p.description)}</span>` : ''}
                </div>`;
            }).join('');

            let actionHeader;
            if (isDb) {
                const badge = actionTypeLabels[action.actionType] || 'SELECT';
                actionHeader = `<span class="proposal-action-type">${badge}</span>
                    <strong>${this.escapeHtml(action.name)}</strong>
                    <span class="param-ref-endpoint">${this.escapeHtml(action.tableName || '')}</span>`;
            } else if (isSoap) {
                actionHeader = `<strong>${this.escapeHtml(action.name)}</strong>
                    <span class="param-ref-endpoint">${this.escapeHtml(action.operation || '')}</span>`;
            } else {
                actionHeader = `<span class="proposal-method">${action.method || 'GET'}</span>
                    <strong>${this.escapeHtml(action.name)}</strong>
                    <span class="param-ref-endpoint">${this.escapeHtml(action.endpoint)}</span>`;
            }

            return `<div class="param-ref-action">
                <div class="param-ref-action-header">
                    ${actionHeader}
                </div>
                ${sendRows ? `<div class="param-ref-section"><div class="param-ref-section-title">Send Parameters:</div>${sendRows}</div>` : ''}
                ${receiveRows ? `<div class="param-ref-section"><div class="param-ref-section-title">Receive Parameters:</div>${receiveRows}</div>` : ''}
            </div>`;
        }).join('');

        const refTitle = isDb ? 'Action Parameter Reference' : isSoap ? 'Operation Parameter Reference' : 'Endpoint Parameter Reference';
        const refHtml = `
            <div class="ai-param-reference">
                <div class="param-ref-header">
                    <span class="glyphicon glyphicon-list"></span>
                    <strong>${refTitle}</strong>
                </div>
                <div class="param-ref-body">
                    ${actionsHtml}
                </div>
            </div>`;

        this.createResponseContainer("ai-param-ref", 'minimal');
        const $container = $('.ai-param-ref');
        $container.find('.ai-status-text').hide();
        $container.find('.message-box').show();
        $container.find('.ai-text').html(refHtml);
        $container.find('.msg-actions').css('visibility', 'visible');

        const chatEl = $(".ai-chat")[0];
        if (chatEl) chatEl.scrollTop = chatEl.scrollHeight;
    }

    skipTest() {
        $('.ai-test-connection-card').remove();
        this.createdProposal = null;
        this.createdResult = null;

        this.createResponseContainer("ai-skip-msg", 'minimal');
        this.setAnswer("ai-skip-msg", {answer: "Test skipped. The connection is ready to use. You can test it manually from the connection details page."});
    }

    showCredentialForm(credData) {
        const fieldsHtml = (credData.requiredParams || []).map(p => `
            <div class="cred-form-field">
                <label class="cred-form-label">${this.escapeHtml(p.label || p.name)}</label>
                <input class="cred-form-input" type="${p.type || 'text'}" data-param-name="${this.escapeHtml(p.name)}" placeholder="${this.escapeHtml(p.label || p.name)}" />
            </div>
        `).join('');

        const html = `
            <div class="ai-credential-form" data-auth-method="${this.escapeHtml(credData.authMethod || '')}" data-login-action="${this.escapeHtml(credData.loginAction || '')}">
                <div class="cred-form-header">
                    <span class="glyphicon glyphicon-lock"></span>
                    <strong>Test Credentials</strong>
                </div>
                <div class="cred-form-body">
                    ${fieldsHtml}
                </div>
                <div class="cred-form-buttons">
                    <button class="proposal-btn proposal-btn-create action-submit-credentials">Submit</button>
                    <button class="proposal-btn proposal-btn-cancel action-skip-test">Skip</button>
                </div>
            </div>`;

        $(".ai-chat").append(html);
        this.messageIndex++;

        const chatEl = $(".ai-chat")[0];
        if (chatEl) chatEl.scrollTop = chatEl.scrollHeight;
    }

    async submitTestCredentials() {
        if (!this.createdProposal || !this.createdResult) return;

        // Collect credentials from form
        const testCredentials = {};
        $('.ai-credential-form .cred-form-input').each(function() {
            const name = $(this).data('param-name');
            const val = $(this).val();
            if (name) testCredentials[name] = val;
        });

        // Disable form
        $('.action-submit-credentials').prop('disabled', true).text('Testing...');
        $('.ai-credential-form input').prop('disabled', true);

        // Create status container
        this.createResponseContainer("ai-cred-test-status", 'minimal', 'Authenticating and testing actions');
        const $statusContainer = $('.ai-cred-test-status');
        this.startStatusCycle($statusContainer, false);

        clearInterval(this._statusInterval);
        const testMessages = ['Authenticating', 'Calling API endpoints', 'Validating responses', 'Fixing receive parameters'];
        let tIdx = 0;
        this._statusInterval = setInterval(() => {
            tIdx = (tIdx + 1) % testMessages.length;
            $statusContainer.find('.ai-status-text').html(`<span class="status-icon">&#9679;</span> ${testMessages[tIdx]}<span class="dot-anim"></span>`);
        }, 3000);

        try {
            const testResult = await AIConnectionBuilder.testConnection(
                this.createdProposal, this.createdResult,
                (msg) => { $statusContainer.find('.ai-status-text').html(`<span class="status-icon">&#9679;</span> ${msg}<span class="dot-anim"></span>`); },
                testCredentials
            );

            this.stopStatusCycle();

            // Remove credential form
            $('.ai-credential-form').remove();

            $statusContainer.find('.ai-status-text').hide();
            $statusContainer.find('.message-box').show();
            $statusContainer.find('.msg-actions').css('visibility', 'visible');

            this.renderTestResults($statusContainer, testResult);

            // Update conversation history with test results
            if (testResult.results) {
                const summary = testResult.results.map(r => `${r.actionName}: ${r.status}`).join(', ');
                this.updateConversationHistory('user', 'Submitted test credentials');
                this.updateConversationHistory('assistant',
                    `Test results for "${this.createdResult.connectionName}": ${summary}`
                );
            }

            if (this.createdProposal) {
                this.showParameterReference(this.createdProposal);
            }

            this.createdProposal = null;
            this.createdResult = null;
        } catch (err) {
            this.stopStatusCycle();
            $('.action-submit-credentials').prop('disabled', false).text('Submit');
            $('.ai-credential-form input').prop('disabled', false);

            $statusContainer.find('.ai-status-text').hide();
            $statusContainer.find('.message-box').show();
            $statusContainer.find('.ai-text').html(`Test failed: ${err.message || 'Unknown error'}`);
            $statusContainer.find('.msg-actions').css('visibility', 'visible');
        }

        const chatEl = $(".ai-chat")[0];
        if (chatEl) chatEl.scrollTop = chatEl.scrollHeight;
    }

    showConnectionTypeChooser() {
        const types = [
            { key: 'rest', icon: 'glyphicon-cloud', title: 'REST Web Services', desc: 'Connect to REST APIs — auto-create from documentation' },
            { key: 'database', icon: 'glyphicon-hdd', title: 'Databases', desc: 'Connect via Connection Agent' },
            { key: 'soap', icon: 'glyphicon-transfer', title: 'SOAP Web Services', desc: 'Connect to SOAP/WSDL services' },
            { key: 'ldap', icon: 'glyphicon-folder-open', title: 'Directory Services', desc: 'LDAP and Active Directory via Connection Agent' },
            { key: 'apps', icon: 'glyphicon-th', title: 'Apps', desc: 'Connect between PerfectApps applications' },
            { key: 'text-files', icon: 'glyphicon-file', title: 'Text Files', desc: 'CSV and delimited files via Connection Agent' },
            { key: 'vectordb', icon: 'glyphicon-grain', title: 'Vector Database', desc: 'Connect to Pinecone for semantic search & RAG on your app data' },
            { key: 'qa', icon: 'glyphicon-question-sign', title: 'Just Ask a Question', desc: 'Get help with connections without creating one' }
        ];

        const optionsHtml = types.map(t => `
            <div class="connection-type-option" data-connection-type="${t.key}">
                <span class="glyphicon ${t.icon}"></span>
                <div>
                    <strong>${t.title}</strong>
                    <p>${t.desc}</p>
                </div>
            </div>`).join('');

        const html = `
            <div class="ai-connection-type-chooser">
                <div class="type-chooser-header">
                    <span class="glyphicon glyphicon-link"></span>
                    <strong>Choose a Connection Type</strong>
                </div>
                <div class="type-chooser-body">
                    <div class="connection-type-options">
                        ${optionsHtml}
                    </div>
                </div>
            </div>`;

        $(".ai-chat").append(html);
        this.messageIndex++;

        const chatEl = $(".ai-chat")[0];
        if (chatEl) chatEl.scrollTop = chatEl.scrollHeight;
    }

    handleConnectionTypeSelection(type) {
        $('.ai-connection-type-chooser').remove();

        // Q&A mode — exit connection building, just chat
        if (type === 'qa') {
            this.connectionBuildingType = null;
            this.connectionJustCreated = false;
            this.userContext = 'Connections';
            this.conversationHistory = [];
            this.createResponseContainer("ai-qa-mode", false);
            this.setAnswer("ai-qa-mode", {
                answer: "Sure! Feel free to ask me any question about connections — setup, troubleshooting, configuration, or anything else."
            });
            return;
        }

        const typeNames = {
            'rest': 'REST Web Service',
            'soap': 'SOAP Web Service',
            'database': 'Database',
            'ldap': 'Directory Services',
            'apps': 'Apps',
            'google-sheets': 'Google Sheets',
            'text-files': 'Text File',
            'vectordb': 'Vector Database'
        };

        const responses = {
            'rest': "Great, you want to create a <strong>REST Web Service</strong> connection!</br>" +
                "Please provide me with one of the following:</br>" +
                "• A link to the API documentation</br>" +
                "• A specification file (<strong>.yaml</strong>, <strong>.yml</strong>, <strong>.json</strong>, <strong>.xml</strong>)</br>" +
                "• A cURL command example</br>" +
                "• Or just describe the API (base URL, endpoints, authentication)",
            'soap': "Great, you want to create a <strong>SOAP Web Service</strong> connection!</br>" +
                "Please provide me with one of the following:</br>" +
                "• The WSDL URL for the service</br>" +
                "• A specification file (<strong>.wsdl</strong>, <strong>.xml</strong>)</br>" +
                "• Or describe the service (URL, operations, authentication)",
            'database': "Great, you want to create a <strong>Database</strong> connection!</br>" +
                "Database connections require a <strong>Connection Agent</strong>. Please provide:</br>" +
                "• Agent URL</br>" +
                "• Username</br>" +
                "• Password",
            'ldap': "Great, you want to create a <strong>Directory Services</strong> connection!</br>" +
                "Directory Services connections require a <strong>Connection Agent</strong>. Please provide:</br>" +
                "• Agent URL</br>" +
                "• Username</br>" +
                "• Password",
            'apps': "Great, you want to create an <strong>Apps</strong> connection!</br>" +
                "This lets you connect to another PerfectApps application.</br>" +
                "Let me get the list of available apps for you...",
            'google-sheets': "Great, you want to create a <strong>Google Sheets</strong> connection!</br>" +
                "Please provide me with:</br>" +
                "• The Google Sheet URL or ID</br>" +
                "• Which sheet/tab you want to access</br>" +
                "• Whether you need read-only or read/write access",
            'text-files': "Great, you want to create a <strong>Text File</strong> connection!</br>" +
                "Text File connections require a <strong>Connection Agent</strong>. Please provide:</br>" +
                "• Agent URL</br>" +
                "• Username</br>" +
                "• Password",
            'vectordb': "Great, let's set up a <strong>Vector Database</strong> connection!</br>" +
                "This will connect to Pinecone for semantic search and RAG on your app data.</br>" +
                "Please provide your Pinecone credentials below."
        };

        const response = responses[type] || "Please describe the connection you'd like to create.";
        const typeName = typeNames[type] || type;

        // Track that we're in a connection-building flow
        this.connectionBuildingType = type;

        // Update userContext so backend knows the specific connection type
        const contextMap = {
            'rest': 'Connections/REST Web Services',
            'soap': 'Connections/SOAP Web Services',
            'database': 'Connections/Database',
            'ldap': 'Connections/Directory Services',
            'apps': 'Connections/Apps',
            'google-sheets': 'Connections/Google Sheets',
            'text-files': 'Connections/Text Files',
            'vectordb': 'Connections/VectorDB'
        };
        if (contextMap[type]) {
            this.userContext = contextMap[type];
        }

        // Reset history and start fresh with the selected type context
        this.conversationHistory = [];
        this.updateConversationHistory('user', `I want to create a ${typeName} connection`);
        this.updateConversationHistory('assistant', this.stripHtml(response));

        this.createResponseContainer("ai-conn-type-" + type, false);
        this.setAnswer("ai-conn-type-" + type, { answer: response });

        // Show input form for agent-based connections (database, text files, directory services)
        if (type === 'database' || type === 'text-files' || type === 'ldap') {
            this.showDatabaseConnectionForm();
        }

        // Auto-fetch app list for Apps connections
        if (type === 'apps') {
            this.askAI('List available apps for me to connect to');
        }

        // Show Vector DB credentials form
        if (type === 'vectordb') {
            this.showVectorDBConnectionForm();
        }
    }

    showDatabaseConnectionForm() {
        const html = `
            <div class="ai-credential-form ai-db-connection-form">
                <div class="cred-form-header">
                    <span class="glyphicon glyphicon-hdd"></span>
                    <strong>Database Connection Details</strong>
                </div>
                <div class="cred-form-body">
                    <div class="cred-form-field">
                        <label class="cred-form-label">Connection Name</label>
                        <input class="cred-form-input" type="text" data-param-name="name" placeholder="e.g., My Database Connection" />
                    </div>
                    <div class="cred-form-field">
                        <label class="cred-form-label">Agent URL</label>
                        <input class="cred-form-input" type="text" data-param-name="agentUrl" placeholder="e.g., http://server:port/ConnectionAgent" />
                    </div>
                    <div class="cred-form-field">
                        <label class="cred-form-label">Username</label>
                        <input class="cred-form-input" type="text" data-param-name="username" placeholder="Database username" />
                    </div>
                    <div class="cred-form-field">
                        <label class="cred-form-label">Password</label>
                        <input class="cred-form-input" type="password" data-param-name="password" placeholder="Database password" />
                    </div>
                </div>
                <div class="cred-form-buttons">
                    <button class="proposal-btn proposal-btn-create action-submit-db-connection">Connect</button>
                    <button class="proposal-btn proposal-btn-cancel action-cancel-db-connection">Cancel</button>
                </div>
            </div>`;

        $(".ai-chat").append(html);
        this.messageIndex++;

        const chatEl = $(".ai-chat")[0];
        if (chatEl) chatEl.scrollTop = chatEl.scrollHeight;
    }

    async submitDatabaseConnection() {
        // Collect form data
        const formData = {};
        $('.ai-db-connection-form .cred-form-input').each(function() {
            const name = $(this).data('param-name');
            const val = $(this).val();
            if (name) formData[name] = val;
        });

        // Validate required fields
        if (!formData.name || !formData.agentUrl || !formData.username || !formData.password) {
            $('.ai-db-connection-form .cred-form-input').each(function() {
                const name = $(this).data('param-name');
                if (name && !$(this).val()) {
                    $(this).css('border-color', '#e74c3c');
                } else {
                    $(this).css('border-color', '');
                }
            });
            return;
        }

        // Disable form
        $('.action-submit-db-connection').prop('disabled', true).text('Connecting...');
        $('.ai-db-connection-form input').prop('disabled', true);

        // Send details to AI via chat — the AI will call check_agent tool
        const message = `Agent URL: ${formData.agentUrl}\nUsername: ${formData.username}\nPassword: ${formData.password}\nConnection Name: ${formData.name}`;

        // Store for later use
        this.pendingDbDetails = formData;

        // Remove form
        $('.ai-db-connection-form').remove();

        // Send as a chat message — backend will call check_agent and return datasource list
        this.askAI(message);
    }

    showVectorDBConnectionForm() {
        const html = `
            <div class="ai-credential-form ai-vectordb-form">
                <div class="cred-form-header vectordb-header">
                    <span class="glyphicon glyphicon-grain"></span>
                    <strong>Vector Database Connection Details</strong>
                </div>
                <div class="cred-form-body">
                    <div class="cred-form-field">
                        <label class="cred-form-label">Provider</label>
                        <select class="cred-form-input vectordb-provider-select" data-param-name="provider">
                            <option value="pinecone" selected>Pinecone</option>
                            <option value="qdrant">Qdrant</option>
                            <option value="chroma">Chroma</option>
                            <option value="zilliz">Zilliz</option>
                            <option value="weaviate">Weaviate</option>
                        </select>
                    </div>
                    <div class="cred-form-field">
                        <label class="cred-form-label">API Key</label>
                        <input class="cred-form-input" type="password" data-param-name="apiKey" placeholder="Your API key" />
                    </div>
                    <div class="cred-form-field vectordb-chat-qdrant-field" style="display:none">
                        <label class="cred-form-label">Cluster URL</label>
                        <input class="cred-form-input" type="text" data-param-name="clusterUrl" placeholder="https://xxx.cloud.qdrant.io:6333" />
                    </div>
                    <div class="cred-form-field vectordb-chat-chroma-field" style="display:none">
                        <label class="cred-form-label">Base URL</label>
                        <input class="cred-form-input" type="text" data-param-name="chromaBaseUrl" placeholder="https://api.trychroma.com" />
                    </div>
                    <div class="cred-form-field vectordb-chat-chroma-field" style="display:none">
                        <label class="cred-form-label">Tenant</label>
                        <input class="cred-form-input" type="text" data-param-name="chromaTenant" placeholder="Chroma Cloud tenant ID" />
                    </div>
                    <div class="cred-form-field vectordb-chat-chroma-field" style="display:none">
                        <label class="cred-form-label">Database</label>
                        <input class="cred-form-input" type="text" data-param-name="chromaDatabase" placeholder="default" value="default" />
                    </div>
                    <div class="cred-form-field vectordb-chat-zilliz-field" style="display:none">
                        <label class="cred-form-label">Cluster Endpoint</label>
                        <input class="cred-form-input" type="text" data-param-name="zillizEndpoint" placeholder="https://in01-xxxx.api.gcp-us-west1.zillizcloud.com" />
                    </div>
                    <div class="cred-form-field vectordb-chat-zilliz-field" style="display:none">
                        <label class="cred-form-label">OpenAI API Key</label>
                        <input class="cred-form-input" type="password" data-param-name="zillizEmbeddingApiKey" placeholder="sk-proj-..." />
                    </div>
                    <div class="cred-form-field vectordb-chat-zilliz-info" style="display:none">
                        <span style="color:#888;font-size:10px;font-style:italic;">Zilliz requires an OpenAI API key to generate embeddings. Your key is stored securely.</span>
                    </div>
                    <div class="cred-form-field vectordb-chat-weaviate-field" style="display:none">
                        <label class="cred-form-label">Instance URL</label>
                        <input class="cred-form-input" type="text" data-param-name="weaviateUrl" placeholder="https://xxx.weaviate.network" />
                    </div>
                    <div class="cred-form-field vectordb-chat-weaviate-field" style="display:none">
                        <label class="cred-form-label">Vectorizer</label>
                        <select class="cred-form-input vectordb-vectorizer-select" data-param-name="weaviateVectorizer">
                            <option value="text2vec-weaviate" selected>text2vec-weaviate (Weaviate Cloud)</option>
                            <option value="text2vec-openai">text2vec-openai (OpenAI)</option>
                        </select>
                    </div>
                    <div class="cred-form-field vectordb-chat-weaviate-openai-field" style="display:none">
                        <label class="cred-form-label">OpenAI API Key</label>
                        <input class="cred-form-input" type="password" data-param-name="weaviateOpenAiKey" placeholder="sk-proj-..." />
                    </div>
                    <div class="cred-form-field vectordb-chat-search-type">
                        <label class="cred-form-label">Search Type</label>
                        <select class="cred-form-input vectordb-search-type-select" data-param-name="searchType">
                            <option value="semantic" selected>Semantic — AI understands meaning</option>
                            <option value="keyword">Keyword — Exact word matching</option>
                            <option value="hybrid">Hybrid — Both combined, best accuracy</option>
                        </select>
                    </div>
                    <div class="cred-form-field vectordb-chat-pinecone-field">
                        <label class="cred-form-label">Namespace <span style="color:#999;font-weight:normal">(optional)</span></label>
                        <input class="cred-form-input" type="text" data-param-name="namespace" placeholder="e.g., my-namespace" />
                    </div>
                </div>
                <div class="cred-form-buttons">
                    <button class="proposal-btn proposal-btn-create action-submit-vectordb-connection">Test & Connect</button>
                    <button class="proposal-btn proposal-btn-cancel action-cancel-vectordb-connection">Cancel</button>
                </div>
            </div>`;

        $(".ai-chat").append(html);
        this.messageIndex++;

        const chatEl = $(".ai-chat")[0];
        if (chatEl) chatEl.scrollTop = chatEl.scrollHeight;
    }

    async submitVectorDBConnection() {
        // Collect form data
        const formData = {};
        $('.ai-vectordb-form .cred-form-input').each(function() {
            const name = $(this).data('param-name');
            const val = $(this).val();
            if (name) formData[name] = val;
        });

        // Validate required fields
        const isQdrant = formData.provider === 'qdrant';
        const isChroma = formData.provider === 'chroma';
        const isZilliz = formData.provider === 'zilliz';
        const isWeaviate = formData.provider === 'weaviate';
        const weaviateNeedsOpenAi = isWeaviate && formData.weaviateVectorizer === 'text2vec-openai';
        if (!formData.apiKey || (isQdrant && !formData.clusterUrl) || (isChroma && !formData.chromaBaseUrl) || (isZilliz && (!formData.zillizEndpoint || !formData.zillizEmbeddingApiKey)) || (isWeaviate && !formData.weaviateUrl) || (weaviateNeedsOpenAi && !formData.weaviateOpenAiKey)) {
            $('.ai-vectordb-form .cred-form-input').each(function() {
                const name = $(this).data('param-name');
                const required = name === 'apiKey' || (isQdrant && name === 'clusterUrl') || (isChroma && name === 'chromaBaseUrl') || (isZilliz && (name === 'zillizEndpoint' || name === 'zillizEmbeddingApiKey')) || (isWeaviate && name === 'weaviateUrl') || (weaviateNeedsOpenAi && name === 'weaviateOpenAiKey');
                if (required && !$(this).val()) {
                    $(this).css('border-color', '#e74c3c');
                } else {
                    $(this).css('border-color', '');
                }
            });
            return;
        }

        // Disable form
        $('.action-submit-vectordb-connection').prop('disabled', true).text('Testing...');
        $('.ai-vectordb-form input, .ai-vectordb-form select').prop('disabled', true);

        // Store for later use
        this.pendingVectorDBDetails = formData;

        // Remove form
        $('.ai-vectordb-form').remove();

        // Send as a chat message — backend will call test_vectordb_connection tool
        let message = `Provider: ${formData.provider}\nAPI Key: ${formData.apiKey}\nSearch Type: ${formData.searchType || 'semantic'}`;
        if (isQdrant) {
            message += `\nCluster URL: ${formData.clusterUrl}`;
        } else if (formData.provider === 'chroma') {
            message += `\nBase URL: ${formData.chromaBaseUrl}`;
            if (formData.chromaTenant) message += `\nTenant: ${formData.chromaTenant}`;
            if (formData.chromaDatabase) message += `\nDatabase: ${formData.chromaDatabase}`;
        } else if (isZilliz) {
            message += `\nCluster Endpoint: ${formData.zillizEndpoint}`;
            message += `\nOpenAI API Key: ${formData.zillizEmbeddingApiKey}`;
        } else if (isWeaviate) {
            message += `\nInstance URL: ${formData.weaviateUrl}`;
            message += `\nVectorizer: ${formData.weaviateVectorizer || 'text2vec-weaviate'}`;
            if (weaviateNeedsOpenAi) message += `\nOpenAI API Key: ${formData.weaviateOpenAiKey}`;
        } else {
            if (formData.namespace) message += `\nNamespace: ${formData.namespace}`;
        }
        this.askAI(message);
    }

    showAppSelectorCard(apps) {
        const appListHtml = apps.map(app => `
            <label class="app-selector-item">
                <input type="checkbox" class="app-selector-checkbox" data-form-id="${app.formId}" data-form-guid="${app.formGUID || ''}" data-form-name="${this.escapeHtml(app.formName)}" />
                <span class="app-selector-name">${this.escapeHtml(app.formName)}</span>
                ${app.instanceCount !== undefined ? `<span class="app-selector-count">${app.instanceCount} instances</span>` : ''}
            </label>`).join('');

        const html = `
            <div class="ai-app-selector-card">
                <div class="app-selector-header">
                    <span class="glyphicon glyphicon-grain"></span>
                    <strong>Select Apps to Sync</strong>
                </div>
                <div class="app-selector-body">
                    <p class="app-selector-desc">Choose which apps should have their instance data synced to the vector database for AI-powered search.</p>
                    <div class="app-selector-list">
                        ${appListHtml}
                    </div>
                    <div class="app-selector-toggle">
                        <a href="#" class="action-select-all-apps">Select All</a>
                    </div>
                </div>
                <div class="app-selector-buttons">
                    <button class="proposal-btn proposal-btn-create action-confirm-app-selection">Continue</button>
                    <button class="proposal-btn proposal-btn-cancel action-skip-app-selection">Skip - Continue without apps</button>
                </div>
            </div>`;

        $(".ai-chat").append(html);
        this.messageIndex++;

        const chatEl = $(".ai-chat")[0];
        if (chatEl) chatEl.scrollTop = chatEl.scrollHeight;
    }

    confirmAppSelection() {
        const selectedApps = [];
        $('.app-selector-checkbox:checked').each(function() {
            selectedApps.push({
                formId: $(this).data('form-id'),
                formGUID: $(this).data('form-guid'),
                formName: $(this).data('form-name'),
                liveSync: true
            });
        });

        this.pendingLinkedApps = selectedApps;
        $('.ai-app-selector-card').remove();

        // Send selected apps to AI to generate the proposal
        if (selectedApps.length > 0) {
            const appNames = selectedApps.map(a => a.formName).join(', ');
            this.askAI(`Link these apps to the vector database: ${appNames}`);
        } else {
            this.askAI('Create the vector database connection without linking any apps');
        }
    }

    skipAppSelection() {
        this.pendingLinkedApps = [];
        $('.ai-app-selector-card').remove();
        this.askAI('Create the vector database connection without linking any apps');
    }

    showBulkSyncPrompt(connectionName, totalInstances, linkedApps) {
        const appDetails = linkedApps.map(app =>
            `<div class="sync-app-row"><span class="glyphicon glyphicon-list-alt"></span> ${this.escapeHtml(app.formName)}${app.instanceCount !== undefined ? ` — ${app.instanceCount} instances` : ''}</div>`
        ).join('');

        const html = `
            <div class="ai-sync-prompt-card">
                <div class="sync-prompt-header">
                    <span class="glyphicon glyphicon-ok-circle"></span>
                    <strong>Connection "${this.escapeHtml(connectionName)}" created successfully!</strong>
                </div>
                <div class="sync-prompt-body">
                    <p>Would you like to sync existing instance data to the vector database now?</p>
                    ${appDetails}
                </div>
                <div class="sync-prompt-buttons">
                    <button class="proposal-btn proposal-btn-create action-sync-now">Sync Now${totalInstances ? ' (' + totalInstances + ' instances)' : ''}</button>
                    <button class="proposal-btn proposal-btn-cancel action-sync-later">Skip — I'll sync later</button>
                </div>
            </div>`;

        $(".ai-chat").append(html);
        this.messageIndex++;

        const chatEl = $(".ai-chat")[0];
        if (chatEl) chatEl.scrollTop = chatEl.scrollHeight;
    }

    async startBulkSync() {
        $('.ai-sync-prompt-card').remove();
        this.askAI('Start bulk sync of all linked apps to the vector database now');
    }

    skipBulkSync() {
        $('.ai-sync-prompt-card').remove();
        this.createResponseContainer("ai-sync-skipped", false);
        this.setAnswer("ai-sync-skipped", {
            answer: "Sync skipped. You can trigger a sync later from the connection details page. Live sync is active — new submissions will be automatically indexed."
        });
        this.showConnectionTypeChooser();
    }

    showConnectionFallback() {
        const isSoap = this.connectionBuildingType === 'soap';

        const restOptions = `
            <div class="fallback-option" data-action="curl">
                <span class="glyphicon glyphicon-console"></span>
                <div>
                    <strong>Paste a cURL command</strong>
                    <p>Copy a cURL request from Postman, browser DevTools, or the API docs and paste it in the chat.</p>
                </div>
            </div>
            <div class="fallback-option" data-action="manual">
                <span class="glyphicon glyphicon-list-alt"></span>
                <div>
                    <strong>Describe the API manually</strong>
                    <p>Tell me the base URL, endpoints, parameters, and authentication method.</p>
                </div>
            </div>
            <div class="fallback-option" data-action="docs-link">
                <span class="glyphicon glyphicon-link"></span>
                <div>
                    <strong>Provide a direct docs link</strong>
                    <p>Share a link to the API reference page (e.g., Swagger/OpenAPI URL).</p>
                </div>
            </div>`;

        const soapOptions = `
            <div class="fallback-option" data-action="wsdl-link">
                <span class="glyphicon glyphicon-link"></span>
                <div>
                    <strong>Provide the WSDL URL</strong>
                    <p>Usually ends with ?wsdl or .wsdl (e.g., https://example.com/service.asmx?wsdl)</p>
                </div>
            </div>
            <div class="fallback-option" data-action="wsdl-file">
                <span class="glyphicon glyphicon-file"></span>
                <div>
                    <strong>Upload a WSDL file</strong>
                    <p>Attach a .wsdl or .xml file using the paperclip button below.</p>
                </div>
            </div>
            <div class="fallback-option" data-action="manual">
                <span class="glyphicon glyphicon-list-alt"></span>
                <div>
                    <strong>Describe the service manually</strong>
                    <p>Tell me the service URL, operations, and authentication method.</p>
                </div>
            </div>`;

        const fallbackHtml = `
            <div class="ai-connection-fallback" data-msg-index="${this.messageIndex}">
                <div class="fallback-header">
                    <span class="glyphicon glyphicon-info-sign"></span>
                    <strong>Could not auto-detect ${isSoap ? 'SOAP service' : 'API'} configuration</strong>
                </div>
                <div class="fallback-body">
                    <p>${isSoap
                        ? 'I wasn\'t able to find a valid WSDL at that URL. You can help me by:'
                        : 'I wasn\'t able to automatically find and parse the API documentation. You can help me by providing the API details in one of these ways:'}</p>
                    <div class="fallback-options">
                        ${isSoap ? soapOptions : restOptions}
                    </div>
                    <div class="fallback-switch">
                        <span class="fallback-switch-link action-switch-connection-type">Wrong connection type? Choose a different one.</span>
                    </div>
                </div>
            </div>`;

        $(".ai-chat").append(fallbackHtml);
        this.messageIndex++;

        const chatEl = $(".ai-chat")[0];
        if (chatEl) chatEl.scrollTop = chatEl.scrollHeight;
    }

    cancelProposal() {
        this.pendingProposal = null;
        $('.ai-connection-proposal').remove();

        // Show a cancelled message
        this.createResponseContainer("ai-cancel-msg", false);
        this.setAnswer("ai-cancel-msg", {answer: "Connection creation cancelled. Feel free to ask me anything else!"});
    }

    navigateToConnection(connectionId) {
        try {
            // Click on the connection in the left panel to navigate to it
            const $link = $(`#dashboard-left-panel a[data-itemid="${connectionId}"]`);
            if ($link.length) {
                $link.trigger('click');
            }
        } catch (e) {
            console.log('Could not auto-navigate to connection:', e);
        }
    }

    closeModal() {
        $(this.El).remove();
    }
}

export default AIChatModal;
